import React, { Component } from "react";
import { connect } from "react-redux";
import Session from "../../../utility/session";
import { planSizeChange, optedPlan, paymentClose, paymentWebhook, paymentAcknowledge } from "../../../common/actions";
import { loadRateCards, getUserCurrentPlan } from "../../../Containers/Pricing/actions";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import moment from "moment";
import { today as todayDate } from "../../../utility/commonHelpers";
import {
  PAYMENT_URL_DOMAIN_PROD,
  PAYMENT_URL_DOMAIN_TIER1,
  PAYMENT_URL_DOMAIN_STAGING,
} from "../../../common/constants";
import { numberWithCommas } from "../../../utility/commonHelpers";
import history from "../../../utility/history";
const styles = {
  header: {
    backgroundColor: "yellow",
    color: "red",
  },
};

const mapStateToProps = (state) => ({
  subscribePlanInfo: state.subscribePlanInfo,
});
const parentStyle = { overflow: "hidden" };

class SubscriptionPlans extends Component {
  constructor(props) {
    super(props);
    this.optPlan = this.optPlan.bind(this);
    this.closeFrame = this.closeFrame.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.state = { width:window.innerWidth }
  }
  handleResize = () => {
    const {innerWidth:width} = window
    this.setState({width})
  } 
  componentWillUnmount(){
    window.removeEventListener("resize", this.handleResize)
  }
  componentDidMount() {
    window.addEventListener("message", receiveMessage.bind(this), false);
    window.addEventListener("resize", this.handleResize)
    function receiveMessage(event) {
      let PAYMENT_URL_DOMAIN;
      if (process.env.REACT_APP_ENV == "production") {
        PAYMENT_URL_DOMAIN = PAYMENT_URL_DOMAIN_PROD;
      } else if (process.env.REACT_APP_ENV == "staging") {
        PAYMENT_URL_DOMAIN = PAYMENT_URL_DOMAIN_STAGING;
      } else {
        PAYMENT_URL_DOMAIN = PAYMENT_URL_DOMAIN_TIER1;
      }
      if (event.origin.indexOf(PAYMENT_URL_DOMAIN) > -1) {
        this.props.dispatch(paymentAcknowledge());
        if (JSON.parse(event.data).status == "success") {
          setTimeout(function () {
            history.push("/dashboard");
          }, 5000);
        }
        // this.props.dispatch(
        //   paymentWebhook({ paymentDetails: event.data, invoiceInfo: this.props.subscribePlanInfo.invoiceInfo })
        // );
      }
    }
    this.props.dispatch(
      getUserCurrentPlan({
        mmCustomerID: Session.getItem(Session.MM_CUSTOMER_ID),
      })
    );
    // if (this.props.subscribePlanInfo.ratecardList.PlanSizes == null) this.props.dispatch(loadRateCards());
    this.props.dispatch(loadRateCards());
  }
  showAlert() {
    alert("This subscription is not available to you now.Please contact us");
  }
  closeFrame(event) {
    event.preventDefault();
    this.props.dispatch(paymentClose());
    if (this.props.subscribePlanInfo.paymentPending) {
      const paymentDetails = {};
      paymentDetails.status = "cancelled";
      this.props.dispatch(
        paymentWebhook({
          paymentDetails: JSON.stringify(paymentDetails),
          invoiceInfo: this.props.subscribePlanInfo.invoiceInfo,
        })
      );
    }
  }
  optPlan(
    planGroupID,
    planname,
    planid,
    size,
    price,
    discountedprice,
    FreequencyId,
    Freequency,
    planGroup,
    perMonthPrice,
    planType,
    liIndex
  ) {
    const that = this;
    return function (event) {
      const today = todayDate();
      const invoice = {};
      //Adjustment amount
      const user = that.props.subscribePlanInfo.userCurrentPlan;
      // console.log("User:" + JSON.stringify(user));
      // if (planType == "daily" && user.daycredits > TRIAL_DAY_CREDITS) {
      //   const planexpireson = moment(user.planexpireson);
      //   const planSubscribedOn = moment(user.planSubscribedOn);
      //   const currentPlanFrequency = planexpireson.diff(planSubscribedOn, "days");

      //   let diff = parseInt(planexpireson.diff(today, "days"));
      //   if (diff <= currentPlanFrequency) diff = diff - 1;
      //   const amount = user.amount;
      //   invoice.adjustment = Math.ceil(diff * (amount / currentPlanFrequency));

      //   invoice.previousPlanAmount = amount;
      //   invoice.previousPlanFrequency = currentPlanFrequency;
      //   invoice.chargePerDay = (amount / currentPlanFrequency).toFixed(2);
      //   invoice.previousPlanUnusedDays = diff;
      // } else invoice.adjustment = 0;
      if (planType == "daily") {
        invoice.adjustment = user.adjustmentDetails.adjustment;
        invoice.previousPlanAmount = user.adjustmentDetails.previousPlanAmount;
        invoice.previousPlanFrequency = user.adjustmentDetails.previousPlanFrequency;
        invoice.chargePerDay = user.adjustmentDetails.chargePerDay;
        invoice.previousPlanUnusedDays = user.adjustmentDetails.previousPlanUnusedDays;
      } else invoice.adjustment = 0;
      invoice.planGroupID = planGroupID;
      invoice.planID = planid;
      invoice.orderDate = moment.utc();
      invoice.price = price;
      invoice.customersID = Session.getItem(Session.MM_CUSTOMER_ID);
      //invoice.adjustment = 0;
      invoice.size = size;
      invoice.FreequencyId = FreequencyId;
      invoice.Freequency = Freequency;
      invoice.planGroup = planGroup;
      invoice.discountedprice = discountedprice;
      invoice.perMonthPrice = perMonthPrice;
      invoice.planType = planType;
      invoice.planexpireson = today.add(parseInt(Freequency), "months").format("MMM DD,YYYY");
      that.props.dispatch(optedPlan({ planDetails: invoice }));
    };
  }
  handleOnChange = (event) => {
    if (event != undefined && parseInt(event) >= 0) {
      this.props.dispatch(
        planSizeChange({
          size: this.props.subscribePlanInfo.ratecardList.PlanSizes[event],
          ratecardList: this.props.subscribePlanInfo.ratecardList,
        })
      );
    }
  };
  calculateRate(DiscountedPrice, Freequency) {
    return (parseInt(DiscountedPrice) / parseInt(Freequency)).toFixed(2);
  }
  calculateSliderValue(value) {
    let retVal;
    if(parseInt(value) >= 1000000) retVal = parseInt(value) / parseInt(1000000) + "M"
    else if (parseInt(value) >= 1000) retVal = parseInt(value) / parseInt(1000) + "k";
    else retVal = value;
    return retVal;
  }
  calculateDisplayValue(value){
    let retVal;
    if(parseInt(value) >= 1000000) retVal = parseInt(value) / parseInt(1000000) + "Million"
    else retVal = numberWithCommas(value);
    return retVal;
  }
  render() {
    const ratecards = this.props.subscribePlanInfo.eligibleRateCards;
    const marksList = this.props.subscribePlanInfo.ratecardList.PlanSizes;
    const userCurrentPlan = this.props.subscribePlanInfo.userCurrentPlan;
    let plns = this.props.subscribePlanInfo.ratecardList.Plans
    let disc = (plns && plns[this.props.subscribePlanInfo.currentValue] || {}).PlanDiscount
    let daycredits = 50;
    let Frequency = 0;
    let currentPlanPrice = 0;
    if (userCurrentPlan) {
      daycredits = userCurrentPlan.daycredits;
      Frequency = userCurrentPlan.Frequency;
      currentPlanPrice = userCurrentPlan.amount;
    }

    let maxSize = 0;
    let minSize = 0;
    let marks = {}, emptyIndexes = {};
    if (marksList) {
      let keys = Object.keys(marksList)
      minSize = parseInt(keys[0]);
      maxSize = parseInt(keys[keys.length - 1]);
      const allPlans = this.props.subscribePlanInfo.ratecardList.Plans;
      // for (const mark of marksList) {
      marksList.forEach((mark, index) => {
        let planDiscount = 0;
        if (allPlans) planDiscount = allPlans[mark].PlanDiscount;
        const marklabel = {
          label: (
            <div>
              {this.calculateSliderValue(mark)}
              {planDiscount == 0 ? (
                ""
              ) : (
                <span className="sliderPercentage" title="discount">
                  ({planDiscount.toFixed(1)}%)
                </span>
              )}
            </div>
          ),
        };
        const emptyLabel = {
          label: (
            <div>
              {(index == 0 || index+1 == marksList.length) ? this.calculateSliderValue(mark) : ""}
            </div>
          ),
        }
        marks = { ...marks, [index]: marklabel };
        emptyIndexes = { ...emptyIndexes, [index]: emptyLabel }
      // }
      })
    }
    return (
      <div className="col-md-8 col-sm-12 col-xs-12">
        <div className="x_panel">
          <div className="x_content">
            <p className="text-center">Drag the slider and choose the right plan for you.</p>
            <div className="priceSlideBar text-center">
              <Slider
                min={minSize}
                max={maxSize}
                marks={this.state.width <= 767 ? emptyIndexes : marks}
                dotStyle={{display:"inline-block"}}
                step={null}
                onChange={this.handleOnChange}
                value={(marksList || []).indexOf(this.props.subscribePlanInfo.currentValue)}
              />
            </div>
            {this.state.width <= 767 ?
              <p className="text-center" style={{color:"#999", fontSize:18}}>
                <strong style={{color:"#52a792"}}>
                  {this.calculateDisplayValue(this.props.subscribePlanInfo.currentValue)}
                </strong> Credits
                {disc ?  
                (
                <div style={{display:"flex", justifyContent:"center"}}>
                  <span style={{fontSize:14}}>(</span>
                  <p className="text-center"
                  style={{
                    marginTop: 2,
                    color: "#52a792", 
                    fontSize:14
                  }}>
                    {`${disc.toFixed(1)}%`}</p>
                  <p className="text-center"
                  style={{
                    marginTop: 2,
                    color: "#f39c12", 
                    fontSize:14
                  }}>&nbsp;
                    {`Discount Applied`}
                  </p>
                  <span style={{fontSize:14}}>)</span>
                </div>
                  )
                : ""}
              </p> 
              : null}
            {this.state.width <= 767 ? "" :
            <p
              className="text-center"
              style={{
                color: "#f39c12",
              }}
            >
              More credits = More discounts (%)
            </p>}
            <div className="priceOptions">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div className="card box-shadow">
                  <div className="card-header">
                    <h3>Subscription</h3>
                    <h4>
                      <strong>{this.calculateDisplayValue(this.props.subscribePlanInfo.currentValue)}</strong> Verifications per
                      day
                    </h4>
                  </div>
                  {ratecards.plans.find(plan => plan.planGroup == "Monthly") ?
                  <div className="card-body">
                    <ul>
                      {ratecards.plans.map((ratecard, index) =>
                        ratecard.IsPersist ? (
                          ""
                        ) : this.props.subscribePlanInfo.currentValue < daycredits ||
                          (this.props.subscribePlanInfo.currentValue == daycredits &&
                            ratecard.Freequency <= Frequency) ||
                          ratecard.DiscountedPrice <= currentPlanPrice ? (
                          <li
                            title="Downgrade not allowed"
                            className={
                              "pricing-excerprt" +
                              (this.props.subscribePlanInfo.optedPlanDetails.planGroupID == ratecard.PlanGroupID &&
                              this.props.subscribePlanInfo.optedPlanDetails.planID == ratecards.PlanID
                                ? " activeBox"
                                : "") +
                              (this.props.subscribePlanInfo.currentValue == daycredits &&
                              ratecard.Freequency == Frequency
                                ? " currentPlan"
                                : "")
                            }
                            key={index}
                          >
                            <div className="column-packTitle">
                              <strike>
                                Billed&nbsp;
                                <strong>{ratecard.planGroup}</strong>
                              </strike>
                              {ratecard.Discount == 0 ? (
                                this.props.subscribePlanInfo.currentValue == daycredits &&
                                ratecard.Freequency == Frequency ? (
                                  <small> Current plan </small>
                                ) : (
                                  ""
                                )
                              ) : (
                                <small>
                                  (Additional discount <strong>{ratecard.Discount}%)</strong>
                                  <br />
                                  {this.props.subscribePlanInfo.currentValue == daycredits &&
                                  ratecard.Freequency == Frequency
                                    ? "Current plan"
                                    : ""}
                                </small>
                              )}
                            </div>
                            <div className="column-packPrice">
                              <span className="packPrice">
                                <strong>
                                  ${this.calculateRate(ratecard.DiscountedPrice, ratecard.Freequency)}
                                  /mo
                                </strong>
                              </span>
                              <a
                                href="javascript:void(0)"
                                className="btn btn-primary buttonBorder not-allowed"
                                data-page="portfolio"
                                title="Downgrade not allowed"
                              >
                                <i className="fa fa-shopping-cart" /> Buy
                              </a>
                            </div>
                          </li>
                        ) : (
                          <li
                            className={
                              "pricing-excerprt" +
                              (this.props.subscribePlanInfo.optedPlanDetails.planGroupID == ratecard.PlanGroupID &&
                              this.props.subscribePlanInfo.optedPlanDetails.planID == ratecards.PlanID
                                ? " activeBox"
                                : "")
                            }
                            key={index}
                          >
                            <div className="column-packTitle">
                              Billed&nbsp;<strong>{ratecard.planGroup}</strong>
                              {ratecard.Discount == 0 ? (
                                ""
                              ) : (
                                <small>
                                  (Additional discount <strong>{ratecard.Discount}%)</strong>
                                </small>
                              )}
                            </div>
                            <div className="column-packPrice">
                              <span className="packPrice">
                                <strong>
                                  ${numberWithCommas(this.calculateRate(ratecard.DiscountedPrice, ratecard.Freequency))}
                                  /mo
                                </strong>
                              </span>
                              <a
                                href="javascript:void(0)"
                                onClick={this.optPlan(
                                  ratecard.PlanGroupID,
                                  ratecards.PlanName,
                                  ratecards.PlanID,
                                  ratecards.Size,
                                  ratecard.Price,
                                  ratecard.DiscountedPrice,
                                  ratecard.FreequencyId,
                                  ratecard.Freequency,
                                  ratecard.planGroup,
                                  this.calculateRate(ratecard.DiscountedPrice, ratecard.Freequency),
                                  "daily",
                                  index
                                )}
                                className={
                                  "btn btn-primary buttonBorder" +
                                  (this.props.subscribePlanInfo.optedPlanDetails.planGroupID == ratecard.PlanGroupID &&
                                  this.props.subscribePlanInfo.optedPlanDetails.planID == ratecards.PlanID
                                    ? " activePlanBtn"
                                    : "")
                                }
                                data-page="portfolio"
                              >
                                <i className="fa fa-shopping-cart" /> Buy
                              </a>
                            </div>
                          </li>
                        )
                      )}
                    </ul>
                  </div> : 
                    <div className="card-body" style={{padding:25}}>
                      <div style={{display:"flex", justifyContent:"space-between"}}>
                        <div>
                        {/* <a href="https://cleanyourlists.com/request-enterprise-quote/" target="_blank" style={{    color: "#2f6bc6",
                                fontSize: 16,
                                letterSpacing: 0,
                                cursor: "pointer"
                                }}>{`Request Quote ›`}</a> */}
                        </div>
                        <div className="pricing-contact">
                        <a target="_blank" href="https://www.mirabeltechnologies.com/contact/" style={{
                                fontSize: 16,
                                letterSpacing: 0,
                                cursor: "pointer"
                                }}>{`Contact Us`}</a>
                        </div>
                      </div>
                    </div>                
                  }
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div className="card box-shadow">
                  <div className="card-header">
                    <h3>One Time</h3>
                    <h4>
                      <strong>{this.calculateDisplayValue(this.props.subscribePlanInfo.currentValue)}</strong> Verifications
                    </h4>
                  </div>
                  <div className="card-body">
                    <ul>
                      {ratecards.plans.map((ratecard, index) =>
                        ratecard.IsPersist ? (
                          <li
                            className={
                              "pricing-excerprt" +
                              (this.props.subscribePlanInfo.optedPlanDetails.planGroupID == ratecard.PlanGroupID &&
                              this.props.subscribePlanInfo.optedPlanDetails.planID == ratecards.PlanID
                                ? " activeBox"
                                : "")
                            }
                            key={index}
                          >
                            <div className="column-packTitle">
                              Billed&nbsp;<strong>Once</strong>{" "}
                            </div>
                            <div className="column-packPrice">
                              <span className="packPrice">
                                <strong>
                                  $
                                  {
                                    // numberWithCommas(ratecard.DiscountedPrice)
                                    numberWithCommas(parseFloat(ratecard.DiscountedPrice).toFixed(2))
                                  }
                                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </strong>
                              </span>
                              <a
                                href="javascript:void(0)"
                                onClick={this.optPlan(
                                  ratecard.PlanGroupID,
                                  ratecards.PlanName,
                                  ratecards.PlanID,
                                  ratecards.Size,
                                  ratecard.Price,
                                  ratecard.DiscountedPrice,
                                  ratecard.FreequencyId,
                                  0,
                                  ratecard.planGroup,
                                  0,
                                  "persistent"
                                )}
                                className={
                                  "btn btn-primary buttonBorder" +
                                  (this.props.subscribePlanInfo.optedPlanDetails.planGroupID == ratecard.PlanGroupID &&
                                  this.props.subscribePlanInfo.optedPlanDetails.planID == ratecards.PlanID
                                    ? " activePlanBtn"
                                    : "")
                                }
                                data-page="portfolio"
                              >
                                <i className="fa fa-shopping-cart" /> Buy
                              </a>
                            </div>
                          </li>
                        ) : (
                          ""
                        )
                      )}
                    </ul>
                  </div>
                </div>
                <small className="body-cover">
                  <br />
                  1 Verification = Valid or Invalid or Unknown Scored email
                  <br />* No credit deduction for Unknown emails
                </small>
              </div>
              <div className={this.state.width <= 767 ? "col-lg-6 col-md-6 col-sm-6 col-xs-12" : "col-lg-6 col-md-6 col-sm-6 col-md-offset-3"}>
                  <div className="card box-shadow">
                    <div className="card-header">
                      <h3>Enterprise</h3>
                      <h4>
                        <strong>1 Million+ </strong> Verifications
                      </h4>
                    </div>
                    <div className="card-body" style={{padding:25}}>
                      <div style={{display:"flex", justifyContent:"space-between"}}>
                        <div>
                        <a href="https://cleanyourlists.com/request-enterprise-quote/" target="_blank" style={{    color: "#2f6bc6",
                                fontSize: 16,
                                letterSpacing: 0,
                                cursor: "pointer"
                                }}>{`Request Quote ›`}</a>
                        </div>
                        <div className="pricing-contact">
                        <a target="_blank" href="https://www.mirabeltechnologies.com/contact/" style={{
                                fontSize: 16,
                                letterSpacing: 0,
                                cursor: "pointer"
                                }}>{`Contact Us`}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        {this.props.subscribePlanInfo.paymentURL === "" ? null : (
          <div id="overlay" className="overlay">
            <div className="payment-modal">
              <a style={{ fontSize: "24px" }} onClick={this.closeFrame} className="close-sign">
                <i className="fa fa-times" aria-hidden="true" />
              </a>
              <iframe style={{ width: "100%", height: "100%" }} src={this.props.subscribePlanInfo.paymentURL} />
            </div>
          </div>
        )}
      </div>
    );
  }
}
export default connect(mapStateToProps)(SubscriptionPlans);



// WEBPACK FOOTER //
// ./src/components/Pricing/PricingContainer/SubscriptionPlans.js